import React from //useEffect, //useState,
//useCallback,
'react';

import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';

const GenericModal = (props) => {
	const {
		title,
		bodyTxt,
		show,
		setShow,
		data, //	pass this back with the response to keep track of things with callbacks
		buttons, // array of button descriptions [{desc:'description 1', id:'closeBtn'}, {desc:'NO NO NO', id:'noBtn'}]
		handleButton,
	} = props;
	//const [show, setShow] = useState(false);
	const handleClose = () => setShow(false);
	//const handleShow = () => setShow(true);
	const handleBtn = (id) => {
		handleClose();
		handleButton({ data, ...{ btnId: id } }); // pass back data prop with id of button clicked
	};

	return (
		<>
			{/* <Button variant="primary" onClick={handleShow}>
			Launch static backdrop modal
			</Button> */}
			<Modal
				show={show}
				onHide={handleClose}
				backdrop="static"
				keyboard={false}
			>
				<Modal.Header closeButton>
					<Modal.Title>{title}</Modal.Title>
				</Modal.Header>
				<Modal.Body>{bodyTxt}</Modal.Body>
				<Modal.Footer>
					{buttons.map((btn, idx) => (
						<Button
							key={idx}
							id={btn.id}
							variant="primary"
							onClick={() => handleBtn(btn.id)}
						>
							{btn.desc}
						</Button>
					))}
				</Modal.Footer>
			</Modal>
		</>
	);
};

export default GenericModal;
